import type { FeatureModule } from '@/shell/registry/types'

export default {
  code: 'automation',
  title: '开发自动化',
  /* 后端 automation 依赖 product（delivery 复用 product.mapping），前端对齐补齐 */
  dependsOn: ['solution'],
  provides: {
    /** 需求交付页内嵌的生成面板 */
    'automation.generation-panel': () => import('./GenerationPanel.vue'),
  },
  routes: [
    { path: '/automation/synthetic', name: 'syntheticWorkbench', component: () => import('./SyntheticWorkbench.vue'), meta: { tab: 'task', title: '合成小需求自动验证' } },
    { path: '/automation/deliveries', name: 'deliveryWorkbench', component: () => import('./DeliveryWorkbench.vue'), meta: { tab: 'task', title: '开发流水线' } },
    { path: '/automation/runs', name: 'automationRuns', component: () => import('./AutomationRuns.vue'), meta: { tab: 'task', title: '构建与验证' } },
    { path: '/automation/model-trial', name: 'modelTrial', component: () => import('./ModelTrial.vue'), meta: { tab: 'task', title: '模型接入验证' } },
  ],
} satisfies FeatureModule
